

















































import { Vue, Component } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition.ts';
import { infoServer } from '@/api/installServer';
import { TableStripe } from '@/mixins/tableStripe';
import PagingUnit from '@/components/paging/paging.vue';

@Component({
  components: { CollapseTransition, PagingUnit },
  mixins: [TableStripe],
})
export default class MessageNotifications extends Vue {
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };

  private loading: any = false; // 表格加载
  private total = 0; // 数据总共多少条
  private editRoleFlag: any = 1; // 控制显示 编辑 页面
  private radio1: any = '消息通知';

  // table 数据对象
  tableData: any = [];

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏或查询按钮触发，隐藏或显示搜索表单内容。
   * @param1 暂无
   * @returns 暂无
   */

  private created() {
    this.getData();
  }

  backFunction() {}

  private getData() {
    infoServer
      .getNotifyReceiverList({
        pageNo: this.queryDataForm.pageNo,
        pageSize: this.queryDataForm.pageSize,
        type: 'NOTICE',
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
  getDataLog() {
    infoServer
      .getSysLogList({
        pageNo: this.queryDataForm.pageNo,
        pageSize: this.queryDataForm.pageSize,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
  radio1Change(e: any) {
    if (e === '消息通知') {
      this.queryDataForm.pageNo = 1;
      this.getData();
    } else if (e === '操作日志') {
      this.queryDataForm.pageNo = 1;
      this.getDataLog();
    }
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    this.queryDataForm.pageNo = 1;
    this.getData();
  }

  /**
   * @desc 点击重置按钮触发，重置搜索表单内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    this.queryDataForm.pageNo = 1;
    this.queryDataForm.pageSize = 10;
    this.getData();
  }
  getListData() {
    if (this.radio1 === '消息通知') {
      this.getData();
    } else if (this.radio1 === '操作日志') {
      this.getDataLog();
    }
  }
}
